import {
  GET_ORGANIZATION,
  GET_ORGANIZATION_ERROR,
  GET_ORGANIZATION_SUCCESS,
  GET_ORGANIZATIONS,
  GET_ORGANIZATIONS_ERROR,
  GET_ORGANIZATIONS_SUCCESS
} from './QuoteSearchFilters.actions'

const quoteSearchFiltersState = {
  error: undefined,
  loading: false,
  organizations: []
}

/**
 * The quote search filters reducer.
 */
const quoteSearchFiltersReducer = (state = quoteSearchFiltersState, { payload, type }) => {
  switch (type) {
    case GET_ORGANIZATION:
    case GET_ORGANIZATIONS: {
      return { ...state, error: undefined, loading: true }
    }
    case GET_ORGANIZATION_ERROR:
    case GET_ORGANIZATIONS_ERROR: {
      return { ...state, error: payload.error, loading: false }
    }
    case GET_ORGANIZATION_SUCCESS:
    case GET_ORGANIZATIONS_SUCCESS: {
      return { ...state, error: undefined, loading: false, organizations: payload.organizations }
    }
    default: {
      return state
    }
  }
}

export default quoteSearchFiltersReducer
